import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentPage: 1,
};

export const paginationSlice = createSlice({
  name: "pagination",
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    updateCurrentPageFromUrl: (state) => {
      const urlSearchParams = new URLSearchParams(window.location.hash);
      const params = {};
      for (let [key, value] of urlSearchParams.entries()) {
        if (key.includes("page")) {
          key = "page";
        }
        params[key] = value.split(",");
      }
      state.currentPage = params?.page ? params.page[0] : 1;
    },
  },
});

export const { setCurrentPage, updateCurrentPageFromUrl } =
  paginationSlice.actions;

export default paginationSlice.reducer;
